function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  "data-name": "Rectangle 203",
  width: 959.386,
  height: 848.341,
  rx: 424.171,
  transform: "rotate(-36.996)",
  x: -380.778,
  y: 223.761,
  fill: "#6080ff"
});

var SvgFoldBg = function SvgFoldBg(props) {
  return React.createElement("svg", _extends({
    width: 937.799,
    height: 915.932,
    viewBox: "0 0 937.799 915.931"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOmNjPSJodHRwOi8vY3JlYXRpdmVjb21tb25zLm9yZy9ucyMiIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyIgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iOTM3Ljc5OSIgaGVpZ2h0PSI5MTUuOTMyIiB2aWV3Qm94PSIwIDAgOTM3Ljc5OSA5MTUuOTMxIiB2ZXJzaW9uPSIxLjEiIGlkPSJzdmczIj48bWV0YWRhdGEgaWQ9Im1ldGFkYXRhOSI+PHJkZjpSREY+PGNjOldvcms+PGRjOmZvcm1hdD5pbWFnZS9zdmcreG1sPC9kYzpmb3JtYXQ+PGRjOnR5cGUgcmRmOnJlc291cmNlPSJodHRwOi8vcHVybC5vcmcvZGMvZGNtaXR5cGUvU3RpbGxJbWFnZSIvPjwvY2M6V29yaz48L3JkZjpSREY+PC9tZXRhZGF0YT48cmVjdCBpZD0iUmVjdGFuZ2xlXzIwMyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMjAzIiB3aWR0aD0iOTU5LjM4NiIgaGVpZ2h0PSI4NDguMzQxIiByeD0iNDI0LjE3MSIgdHJhbnNmb3JtPSJyb3RhdGUoLTM2Ljk5NTg5OCkiIHg9Ii0zODAuNzc4IiB5PSIyMjMuNzYxIiBmaWxsPSIjNjA4MGZmIiBzdHJva2Utd2lkdGg9IjEuMDAwNDAyNDUiLz48L3N2Zz4=";
export { SvgFoldBg as ReactComponent };